import { render, staticRenderFns } from "./BoxHireRequest.vue?vue&type=template&id=16e5d9a7&"
import script from "./BoxHireRequest.vue?vue&type=script&lang=js&"
export * from "./BoxHireRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports